/**
 *
 * Asynchronously loads the component for TransactionsPage
 *
 */
import { lazyLoad } from "utils";

export const TransactionsPageLazy = lazyLoad(
  () => import("./index"),
  (module) => module.TransactionsPage
);

export const TransactionsDetailsPageLazy = lazyLoad(
  () => import("./transactions-details"),
  (module) => module.TransactionDetailsPage
);
